import { request } from '@/shared/api/request'

export const getStatInfo = (params) => {
	return request({
		method: 'get',
		url: 'staff/structure/statInfo',
		params: params
	})
}
